import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { confirmAlert } from "react-confirm-alert";
import {
  Button,
  TextField,
  Grid,
  Box,
  Typography,
  Paper,
  Stack,
  IconButton,
  InputAdornment,
  useMediaQuery,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import DeleteIcon from "@mui/icons-material/Delete";
import { DataGrid } from "@mui/x-data-grid";
import {
  Loading_Box_PalletId_Barcode_Scanning,
  Loading_Box_PalletId_Delete,
  Loading_Box_PalletId_Grid,
  Loading_Box_PalletId_Save,
} from "./LoadingAction";
import {
  fAlertToast,
  fcheck_null_undefine_replace_empty,
  fKeyTabInput,
} from "../../Utility/Utilitys";

const LoadingPalletId = ({selectedData}) => {
  const vMediaQuery = useMediaQuery("(max-width:650px)");
  const palletHead = useSelector(
    (state) => state.SliceLoading.value.PalltetHead
  );
  const [itemDetails, setItemDetails] = useState({
    palletId: "",
    itemCode: "",
    itemName: "",
    srNo: 0,
    quantity: 1,
  });
  const [errors, setErrors] = useState({
    palletId: "",
    itemCode: "",
    itemName: "",
    srNo: "",
    quantity: "",
  });
  const [gridData, setGridData] = useState([]);

  const handleDetailChange = (e) => {
    const { name: field, value } = e.target;
    setItemDetails((prev) => ({
      ...prev,
      [field]: value,
    }));
    // Dynamically clear error if user enters a valid value
    setErrors((prev) => ({
      ...prev,
      [field]: value.trim() ? "" : `${field} is required`,
    }));
  };

  // const getBarcodeApi = async () => {
  //   try {
  //     const response = await Loading_Box_PalletId_Barcode_Scanning(
  //       fcheck_null_undefine_replace_empty({
  //         Barcode: itemDetails?.palletId || "",
  //         Loc: palletHead?.Loc || "",
  //       })
  //     );

  //     if (response?.status === 200) {
  //       let result = response?.data?.ResultSet;

  //       if (result?.length > 0) {
  //         setItemDetails((pre) => ({
  //           ...pre,
  //           palletId: result[0]?.Barcode,
  //           itemCode: result[0]?.ItmCd,
  //           itemName: result[0]?.Name2,
  //         }));
  //         setErrors({
  //           palletId: "",
  //           itemCode: "",
  //           itemName: "",
  //           srNo: "",
  //           quantity: "",
  //         });
  //         //fAlertToast("SUCCESS", "Barcode scanned successfully");
  //         setTimeout(() => {
  //           document.getElementById("qty").focus();
  //         }, 500);
  //       } else {
  //         fAlertToast("FAILED", "Barcode not found");
  //       }
  //     } else {
  //       fAlertToast("FAILED", "Failed to fetch barcode details");
  //     }
  //   } catch (error) {
  //     console.error("Error fetching cycle count data:", error);
  //     fAlertToast("ERROR", "An error occurred while scanning the barcode");
  //   }
  // };

  const getBarcodeApi = async () => {
    const response = await Loading_Box_PalletId_Barcode_Scanning(
      fcheck_null_undefine_replace_empty({
        Barcode: itemDetails?.palletId || "",
        Loc: selectedData?.LocCode || "",
      })
    );
    if (response?.status === 200) {
      let result = response?.data?.ResultSet;

      if (result?.length > 0) {
        setItemDetails((prev) => ({
          ...prev,
          palletId: result[0]?.Barcode,
          itemCode: result[0]?.ItmCd,
          itemName: result[0]?.Name2,
        }));

        setErrors((prevErrors) => ({
          ...prevErrors,
          palletId: "",
          itemCode: "",
          itemName: "",
        }));

        setTimeout(() => {
          document.getElementById("qty").focus();
        }, 500);
      } else {
        fAlertToast("FAILED", "Barcode not found");
      }
    }
  };

  const getGridData = async () => {
    const response = await Loading_Box_PalletId_Grid(
      fcheck_null_undefine_replace_empty({
        VocTyp: selectedData?.DocTyp || "",
        VocNo: selectedData?.DocNo || "",
      })
    );
    if (response?.status === 200 && response?.data?.ResultSet)
      setGridData(response?.data?.ResultSet);
  };

  const handleNew = () => {
    setItemDetails({
      palletId: "",
      itemCode: "",
      itemName: "",
      srNo: 0,
      quantity: 1,
    });
    setErrors({
      palletId: "",
      itemCode: "",
      itemName: "",
      srNo: "",
      quantity: "",
    });
  };

  const handleSave = async () => {
    const validationErrors = {};

    if (!itemDetails?.palletId?.trim()) {
      validationErrors.palletId = "Pallet ID is required";
    }
    if (!itemDetails?.itemCode?.trim()) {
      validationErrors.itemCode = "Item Code is required";
    }
    if (!itemDetails?.itemName?.trim()) {
      validationErrors.itemName = "Item Name is required";
    }
    if (!itemDetails?.quantity?.toString().trim()) {
      validationErrors.quantity = "Quantity is required";
    } else if (Number(itemDetails?.quantity) === 0) {
      validationErrors.quantity = "Quantity should not be zero";
    }

    // If there are validation errors, update state and return
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    try {
      const response = await Loading_Box_PalletId_Save(
        fcheck_null_undefine_replace_empty({
          SrNo: itemDetails?.srNo || 0,
          Qty: itemDetails?.quantity || "",
          ItmCd: itemDetails?.itemCode || "",
          Barcode: itemDetails?.palletId || "",
          VocTyp: selectedData?.DocTyp || "",
          VocNo: selectedData?.DocNo || "",
        })
      );

      if (response?.status === 200 && response?.data?.Type === "Success") {
        console.log("data", response?.data);
        setErrors({}); // Clear errors on success
        handleNew(); // Reset form
        getGridData();
        fAlertToast("SUCCESS", "Data saved successfully");
      }
    } catch (error) {
      console.error("Error saving data:", error);
    }
  };

  const handleDeleteConfirm = async (rowID) => {
    const response = await Loading_Box_PalletId_Delete(
      fcheck_null_undefine_replace_empty({
        SrNo: rowID || "",
        VocTyp: selectedData?.DocTyp || "",
        VocNo: selectedData?.DocNo || "",
      })
    );
    if (response?.status === 200 && response?.data?.Type === "Success") {
      fAlertToast("SUCCESS", response?.data?.Status);
      getGridData();
    }
  };

  const fbarcodeScan = (e) => {
    if (e.key === "Enter") {
      getBarcodeApi();
    }
    if (e.key === "Backspace") {
      setItemDetails((pre) => ({
        ...pre,
        palletId: "",
        itemCode: "",
        itemName: "",
      }));
      setErrors({
        palletId: "",
        itemCode: "",
        itemName: "",
        quantity: "",
      });
    }
  };

  const fContent_Focus = (e) => {
    if (e.target.value == 0) {
      setItemDetails((obj) => ({
        ...obj,
        [e.target.name]: "",
      }));
    }
  };
  const fContent_Blur = (e) => {
    if (e.target.value === "" || e.target.value === 0) {
      setItemDetails((obj) => ({
        ...obj,
        [e.target.name]: Number(0).toFixed(2),
      }));
    }
  };

  const handleRowClick = (params, event) => {
    if (params.field === "delete") {
      event.stopPropagation(); // Prevent row selection when clicking the delete button
    }
    setItemDetails({
      srNo: params?.row?.I_SrNo,
      palletId: params?.row?.I_Barcode,
      itemCode: params?.row?.I_ItmCd,
      itemName: params?.row?.Item_Name,
      quantity: params?.row?.I_Qty,
    });
  };

  useEffect(() => {
    getGridData();
    document.getElementsByName("palletId")[0]?.focus();
  }, []);

  const columns = [
    { field: "I_Barcode", headerName: "Pallet ID", width: 120 },
    { field: "I_ItmCd", headerName: "Item Code", width: 120 },
    {
      field: "Item_Name",
      headerName: "Item Name",
      width: vMediaQuery ? 260 : 550,
    },
    {
      field: "I_Qty",
      headerName: "Qty",
      width: 60,
      alignItems: "center",
      valueFormatter: (params) => Number(params.value),
    },
    {
      field: "delete",
      headerName: "Action",
      width: 60,
      renderCell: (params) => (
        <IconButton
          disabled={palletHead.Status === "Completed"}
          color="error"
          onClick={(event) => {
            event.stopPropagation(); // Prevent row selection on click
            setTimeout(() => {
              confirmAlert({
                title: "Delete",
                message: "Are you sure you want to delete ?",
                buttons: [
                  {
                    label: "Yes",
                    onClick: () => {
                      handleDeleteConfirm(params.row.I_SrNo);
                    },
                  },
                  {
                    label: "No",
                    onClick: () => {
                      return false;
                    },
                  },
                ],
              });
            }, 200);
          }}
        >
          <DeleteIcon />
        </IconButton>
      ),
    },
  ];

  const headData = {
    // "Doc Type Code": palletHead?.VocTyp || "",
    "Doc Type Name": selectedData?.DocName || "",
    "Doc No": selectedData?.DocNo || "",
    "Truck Name": selectedData?.Truck || "",
    "Location ID & Name":
      (selectedData?.LocCode || "") + " - " + (selectedData?.LocName || ""),
  };
  
  return (
    <Box
      sx={{
        px: vMediaQuery ? 0 : 0,
        pt: vMediaQuery ? 1 : 1,
        pb: vMediaQuery ? 0 : 1,
      }}
    >
      <Paper elevation={2} sx={{ p: 1, mb: 2 }}>
        <Grid container spacing={1}>
          <Grid item xs={12} sm={7}>
            {Object.entries(headData).map(([label, value], index) => (
              <Stack
                direction="row"
                justifyContent="space-between"
                key={`box-detail-${index}`}
              >
                <Typography
                  variant="body1"
                  sx={{ width: vMediaQuery ? "40%" : "30%" }}
                  fontWeight="bolder"
                >
                  {label}
                </Typography>
                <Typography
                  variant="body1"
                  sx={{ width: "5%" }}
                  fontWeight="bolder"
                >
                  :
                </Typography>
                <Typography variant="body1" sx={{ width: "65%" }}>
                  {value}
                </Typography>
              </Stack>
            ))}
          </Grid>
          <Grid item xs={12} sm={5}>
            <Stack
              spacing={1}
              mt={vMediaQuery ? 0 : 2.5}
              direction={{ xs: "row" }}
              alignItems={"center"}
              justifyContent={"center"}
            >
              <Button
                variant="contained"
                color="info"
                disabled={palletHead.Status === "Completed"}
                size="small"
                sx={{ width: "fit-content" }}
                onClick={handleNew}
              >
                New
              </Button>
              <Button
                variant="contained"
                color="success"
                disabled={palletHead.Status === "Completed"}
                size="small"
                onClick={handleSave}
                sx={{ ml: 2, width: "fit-content" }}
              >
                Save
              </Button>
            </Stack>
          </Grid>
        </Grid>
      </Paper>
      <Grid
        container
        columnSpacing={{ xs: 0.5, sm: 1, md: 1, lg: 1 }}
        rowSpacing={{ xs: 1.5, sm: 2, md: 2, lg: 3 }}
      >
        <Grid item xs={7.5} md={3}>
          <TextField
            label="Pallet ID"
            value={itemDetails?.palletId}
            fullWidth
            id="palletId"
            name="palletId"
            onChange={handleDetailChange}
            onKeyDown={fbarcodeScan}
            autoComplete="off"
            error={!!errors?.palletId}
            helperText={errors?.palletId || ""}
            sx={{
              "& .MuiOutlinedInput-root": {
                paddingRight: "0px !important",
              },
              "& .MuiInputBase-input": {
                padding: "5.5px 0px 5.5px 10px !important",
                height: "22px",
              },
            }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    onClick={() => getBarcodeApi()}
                    sx={{
                      "& .MuiButtonBase-root": {
                        padding: "0px !important",
                      },
                    }}
                  >
                    <SearchIcon />
                  </IconButton>
                </InputAdornment>
              ),
            }}
            InputLabelProps={{
              shrink: true,
            }}
          />
        </Grid>
        <Grid item xs={4.5} md={1.6}>
          <TextField
            sx={{
              "& .MuiOutlinedInput-input.Mui-disabled": {
                WebkitTextFillColor: "rgb(0 0 0 / 84%) !important",
              },
            }}
            label="Item Code"
            value={itemDetails?.itemCode}
            name="itemCode"
            error={!!errors?.itemCode}
            helperText={errors?.itemCode || ""}
            fullWidth
            disabled
            autoComplete="off"
            size="small"
            InputLabelProps={{
              shrink: true,
            }}
          />
        </Grid>
        <Grid item xs={10.2} md={6.6}>
          <TextField
            sx={{
              "& .MuiOutlinedInput-input.Mui-disabled": {
                WebkitTextFillColor: "rgb(0 0 0 / 84%) !important",
              },
            }}
            value={itemDetails?.itemName}
            label="Item Name"
            fullWidth
            id="itemName"
            name="itemName"
            error={!!errors?.itemName}
            helperText={errors?.itemName || ""}
            disabled
            size="small"
            InputLabelProps={{
              shrink: true,
            }}
          />
        </Grid>
        <Grid item xs={1.8} md={0.8}>
          <TextField
            sx={{
              "& .MuiOutlinedInput-input.Mui-disabled": {
                WebkitTextFillColor: "rgb(0 0 0 / 84%) !important",
              },
            }}
            label="Qty"
            value={itemDetails?.quantity}
            fullWidth
            id="qty"
            name="quantity"
            size="small"
            // onChange={handleDetailChange}
            // error={!!errors?.quantity}
            // helperText={errors?.quantity || ""}
            autoComplete="off"
            InputLabelProps={{
              shrink: true,
            }}
            disabled
          />
        </Grid>
      </Grid>
      <Box sx={{ height: "48vh", mt: 2 }}>
        <DataGrid
          rows={gridData}
          columns={columns}
          rowHeight={30}
          headerHeight={40}
          onRowClick={handleRowClick}
          getRowId={(row) => row.I_SrNo}
          pageSize={5}
          rowsPerPageOptions={[5]}
        />
      </Box>
    </Box>
  );
};

export default LoadingPalletId;
